import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PROJECT_TYPES = [
  "Cortometraggio Indipendente",
  "Lungometraggio / Film",
  "Opera Visiva / Installazione",
  "Sound Design / Effetti",
  "Altro",
];

const inputClass =
  "w-full bg-[#090a0f] border border-[#212638] rounded-xl px-4 py-3 text-sm text-white focus:outline-none focus:border-indigo-500 transition-colors";
const labelClass = "block text-xs font-mono-code text-[#94a3b8] mb-2 uppercase";

export const ContactForm = () => {
  const [form, setForm] = useState({ name: "", email: "", project_type: PROJECT_TYPES[0], timing: "", message: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const update = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/commissions`, form);
      setSent(true);
      setForm({ name: "", email: "", project_type: PROJECT_TYPES[0], timing: "", message: "" });
      toast.success("Richiesta inviata. Ti risponderò al più presto.");
    } catch (err) {
      toast.error("Invio non riuscito. Riprova tra poco.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" data-testid="contact-section" className="py-24 px-6 border-b border-[#1e2335] relative">
      <div className="max-w-3xl mx-auto space-y-10">
        <div className="text-center space-y-3">
          <span className="text-xs font-mono-code text-[#818cf8] uppercase tracking-widest">PARLAMI DEL TUO PROGETTO</span>
          <h2 className="text-3xl md:text-5xl font-disp font-bold text-white">Commissiona la Colonna Sonora</h2>
          <p className="font-serif-body text-base text-[#94a3b8]">
            Invia i dettagli del tuo cortometraggio, film o opera visiva. Riceverai una risposta direttamente via email.
          </p>
        </div>

        {sent ? (
          <div
            data-testid="commission-success"
            className="bg-[#111320] border border-emerald-500/40 p-8 rounded-2xl shadow-xl text-center space-y-4"
          >
            <h3 className="font-disp font-bold text-white text-xl">Richiesta ricevuta</h3>
            <p className="font-serif-body text-sm text-[#94a3b8]">
              Grazie per avermi scritto: la tua richiesta &egrave; arrivata. Ti ricontatter&ograve; via email per parlarne.
            </p>
            <button
              type="button"
              data-testid="commission-new-button"
              onClick={() => setSent(false)}
              className="px-6 py-3 rounded-xl border border-[#2d334d] text-white text-sm font-disp font-medium hover:bg-[#161926] transition-colors"
            >
              Invia un'altra richiesta
            </button>
          </div>
        ) : (
          <form
            data-testid="commission-form"
            onSubmit={handleSubmit}
            className="space-y-6 bg-[#111320] border border-[#212638] p-8 rounded-2xl shadow-xl"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className={labelClass} htmlFor="commission-name">Tuo Nome / Regista</label>
                <input
                  type="text"
                  id="commission-name"
                  data-testid="commission-name-input"
                  required
                  value={form.name}
                  onChange={update("name")}
                  placeholder="Es. Marco Rossi"
                  className={inputClass}
                />
              </div>
              <div>
                <label className={labelClass} htmlFor="commission-email">Email di Contatto</label>
                <input
                  type="email"
                  id="commission-email"
                  data-testid="commission-email-input"
                  required
                  value={form.email}
                  onChange={update("email")}
                  placeholder="regista@produzione.it"
                  className={inputClass}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className={labelClass} htmlFor="commission-type">Tipologia Opera</label>
                <select
                  id="commission-type"
                  data-testid="commission-type-select"
                  value={form.project_type}
                  onChange={update("project_type")}
                  className={inputClass}
                >
                  {PROJECT_TYPES.map((t) => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className={labelClass} htmlFor="commission-timing">Tempistica / Deadline</label>
                <input
                  type="text"
                  id="commission-timing"
                  data-testid="commission-timing-input"
                  value={form.timing}
                  onChange={update("timing")}
                  placeholder="Es. Entro 2 mesi"
                  className={inputClass}
                />
              </div>
            </div>

            <div>
              <label className={labelClass} htmlFor="commission-message">Note sul mood o link alla sceneggiatura</label>
              <textarea
                id="commission-message"
                data-testid="commission-message-textarea"
                rows="4"
                required
                value={form.message}
                onChange={update("message")}
                placeholder="Descrivi il tono visivo, riferimenti musicali ed esigenze del progetto..."
                className={inputClass}
              ></textarea>
            </div>

            <button
              type="submit"
              data-testid="commission-submit-button"
              disabled={sending}
              className="w-full py-4 rounded-xl bg-[#6366f1] hover:bg-[#4f46e5] disabled:opacity-60 disabled:cursor-not-allowed text-white font-disp font-bold text-sm tracking-wide shadow-lg shadow-indigo-950/60 transition-colors"
            >
              {sending ? "Invio in corso..." : "Invia Richiesta di Commissione"}
            </button>
          </form>
        )}
      </div>
    </section>
  );
};
